import type { DesktopAppBranding } from "@afar-research/contracts";
import { formatAppDisplayName, resolveAppBrandBadge, resolveAppStageLabel } from "./branding.logic";

function readInjectedDesktopAppBranding(): DesktopAppBranding | null {
  if (typeof window === "undefined") {
    return null;
  }

  return window.desktopBridge?.getAppBranding?.() ?? null;
}

const injectedDesktopAppBranding = readInjectedDesktopAppBranding();
export const APP_BASE_NAME = injectedDesktopAppBranding?.baseName ?? "AFAR Research";
export const APP_VERSION = import.meta.env.APP_VERSION || "0.0.0";
export const APP_STAGE_LABEL = resolveAppStageLabel({
  injectedStageLabel: injectedDesktopAppBranding?.stageLabel,
  isDevelopmentBuild: import.meta.env.DEV,
  buildStageLabel: import.meta.env.APP_STAGE_LABEL,
});
export const APP_DISPLAY_NAME =
  injectedDesktopAppBranding?.displayName ??
  formatAppDisplayName({ baseName: APP_BASE_NAME, stageLabel: APP_STAGE_LABEL });
export const APP_BRAND_BADGE = resolveAppBrandBadge({
  stageLabel: APP_STAGE_LABEL,
  version: APP_VERSION,
});
